// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wallet detail activity — alinhado ao protótipo pi-proposal #wallet/casas-bahia */
/*
  Sem overflow: hidden. Os filtros do corpo (datepicker e menus da Shoreline)
  abrem em position: absolute e passam da borda do card; recortar aqui cortaria
  esses popovers. Nenhum filho tem fundo nos cantos, então o raio não precisa
  de clip — quem rola horizontalmente é .tableScroll, que se contém sozinho.
*/
.dKsuX1mifwJ3CBzPfeYu {
  background: var(--sl-bg-base);
  border: var(--sl-border-base);
  border-radius: var(--sl-radius-3);
  margin-bottom: var(--sl-space-4);
}

.WprmNdB6sxlRLdmdQMaR {
  padding: var(--sl-space-4) var(--sl-space-5);
  border-bottom: var(--sl-border-base);
}

.rkfaOwBaRsv7mzck3NIb {
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-3);
  padding-bottom: 0;
}

.EReLNh6CtS5t_EBWs91f {
  margin: 0;
  font: var(--sl-text-display-3-font);
  letter-spacing: var(--sl-letter-spacing-2);
  color: var(--sl-fg-base);
}

.WNpsIll0W4TW35uMpdiK {
  display: flex;
  gap: var(--sl-space-4);
  margin: 0 calc(-1 * var(--sl-space-5));
  padding: 0 var(--sl-space-5);
}

.WNpsIll0W4TW35uMpdiK .mb-3 {
  margin-bottom: 0 !important;
}

.WNpsIll0W4TW35uMpdiK .border-bottom {
  border-bottom: none !important;
}

.WNpsIll0W4TW35uMpdiK a,
.WNpsIll0W4TW35uMpdiK button {
  min-height: 2.75rem;
  padding: 0 !important;
  color: var(--sl-fg-base-soft) !important;
  font: var(--sl-text-action-font);
  border-bottom: 2px solid transparent !important;
  margin-bottom: -1px;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none;
}

.WNpsIll0W4TW35uMpdiK a:hover,
.WNpsIll0W4TW35uMpdiK button:hover {
  color: var(--sl-fg-base) !important;
}

.WNpsIll0W4TW35uMpdiK a:focus-visible,
.WNpsIll0W4TW35uMpdiK button:focus-visible {
  box-shadow: var(--sl-focus-ring-accent) !important;
}

.WNpsIll0W4TW35uMpdiK a.active,
.WNpsIll0W4TW35uMpdiK a[aria-current='page'],
.WNpsIll0W4TW35uMpdiK .active {
  color: var(--sl-fg-accent) !important;
  border-bottom-color: var(--sl-fg-accent) !important;
  font-weight: 600;
}

.XhqA3E2SpPgik3Y9LiQN {
  padding: var(--sl-space-4) var(--sl-space-5);
  min-width: 0;
  overflow: visible;
}

.XhqA3E2SpPgik3Y9LiQN .d-flex.flex-wrap.align-items-center.gap-2.mb-3 {
  display: flex;
  align-items: center;
  gap: var(--sl-space-3);
  flex-wrap: wrap;
  margin-bottom: var(--sl-space-3) !important;
}

.XhqA3E2SpPgik3Y9LiQN footer {
  margin-top: var(--sl-space-3);
}

.St_XIdXAYUvdioM722kL {
  overflow-x: auto;
  max-width: 100%;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.St_XIdXAYUvdioM722kL::-webkit-scrollbar {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/modules/retailMedia/components/WalletTableTransaction/walletActivitySection.module.css"],"names":[],"mappings":"AAAA,mFAAmF;AACnF;;;;;CAKC;AACD;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;EAC5C,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,0CAA0C;EAC1C,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,wCAAwC;EACxC,gCAAgC;EAChC,+CAA+C;EAC/C,mBAAmB;EACnB,2BAA2B;EAC3B,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA;;;EAGE,qCAAqC;EACrC,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* Wallet detail activity — alinhado ao protótipo pi-proposal #wallet/casas-bahia */\n/*\n  Sem overflow: hidden. Os filtros do corpo (datepicker e menus da Shoreline)\n  abrem em position: absolute e passam da borda do card; recortar aqui cortaria\n  esses popovers. Nenhum filho tem fundo nos cantos, então o raio não precisa\n  de clip — quem rola horizontalmente é .tableScroll, que se contém sozinho.\n*/\n.section {\n  background: var(--sl-bg-base);\n  border: var(--sl-border-base);\n  border-radius: var(--sl-radius-3);\n  margin-bottom: var(--sl-space-4);\n}\n\n.sectionHead {\n  padding: var(--sl-space-4) var(--sl-space-5);\n  border-bottom: var(--sl-border-base);\n}\n\n.sectionHeadWithTabs {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sl-space-3);\n  padding-bottom: 0;\n}\n\n.heading {\n  margin: 0;\n  font: var(--sl-text-display-3-font);\n  letter-spacing: var(--sl-letter-spacing-2);\n  color: var(--sl-fg-base);\n}\n\n.tabs {\n  display: flex;\n  gap: var(--sl-space-4);\n  margin: 0 calc(-1 * var(--sl-space-5));\n  padding: 0 var(--sl-space-5);\n}\n\n.tabs :global(.mb-3) {\n  margin-bottom: 0 !important;\n}\n\n.tabs :global(.border-bottom) {\n  border-bottom: none !important;\n}\n\n.tabs :global(a),\n.tabs :global(button) {\n  min-height: 2.75rem;\n  padding: 0 !important;\n  color: var(--sl-fg-base-soft) !important;\n  font: var(--sl-text-action-font);\n  border-bottom: 2px solid transparent !important;\n  margin-bottom: -1px;\n  border-radius: 0 !important;\n  background: transparent !important;\n  box-shadow: none;\n}\n\n.tabs :global(a:hover),\n.tabs :global(button:hover) {\n  color: var(--sl-fg-base) !important;\n}\n\n.tabs :global(a:focus-visible),\n.tabs :global(button:focus-visible) {\n  box-shadow: var(--sl-focus-ring-accent) !important;\n}\n\n.tabs :global(a.active),\n.tabs :global(a[aria-current='page']),\n.tabs :global(.active) {\n  color: var(--sl-fg-accent) !important;\n  border-bottom-color: var(--sl-fg-accent) !important;\n  font-weight: 600;\n}\n\n.sectionBody {\n  padding: var(--sl-space-4) var(--sl-space-5);\n  min-width: 0;\n  overflow: visible;\n}\n\n.sectionBody :global(.d-flex.flex-wrap.align-items-center.gap-2.mb-3) {\n  display: flex;\n  align-items: center;\n  gap: var(--sl-space-3);\n  flex-wrap: wrap;\n  margin-bottom: var(--sl-space-3) !important;\n}\n\n.sectionBody :global(footer) {\n  margin-top: var(--sl-space-3);\n}\n\n.tableScroll {\n  overflow-x: auto;\n  max-width: 100%;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.tableScroll::-webkit-scrollbar {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `dKsuX1mifwJ3CBzPfeYu`,
	"sectionHead": `WprmNdB6sxlRLdmdQMaR`,
	"sectionHeadWithTabs": `rkfaOwBaRsv7mzck3NIb`,
	"heading": `EReLNh6CtS5t_EBWs91f`,
	"tabs": `WNpsIll0W4TW35uMpdiK`,
	"sectionBody": `XhqA3E2SpPgik3Y9LiQN`,
	"tableScroll": `St_XIdXAYUvdioM722kL`
};
export default ___CSS_LOADER_EXPORT___;
